import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { OrganizationAccountGroupService } from "@front/m19-services";
import { map, take } from "rxjs";

export const suspensionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const organizationAccountGroupService = inject(OrganizationAccountGroupService);

  return organizationAccountGroupService.blockingSuspendedOrganization$.pipe(
    take(1),
    map((suspendedOrg) => {
      if (suspendedOrg) {
        return router.createUrlTree(["/suspension"]);
      }
      return true;
    }),
  );
};
